import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';

// @ts-expect-error no declarations found for module
import { logInteraction } from 'LayoutBuilderUI/actions/ApiActions';
// @ts-expect-error no declarations found for module
import { openModal } from 'LayoutBuilderUI/actions/CrossFrameActions';
import { MODAL_TYPES } from 'ContentEditorUI/lib/modalConstants';
import { jsx as _jsx } from "react/jsx-runtime";
const ManageSectionsButton = ({
  disabled
}) => {
  const onClick = () => {
    logInteraction({
      action: 'Template Action',
      event: 'open-manage-sections'
    });
    openModal(MODAL_TYPES.MANAGE_SAVED_SECTIONS);
  };
  return /*#__PURE__*/_jsx(Button, {
    use: "link",
    disabled: disabled,
    onClick: onClick,
    "data-test-id": "save-section-manage-button",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "layoutBuilder.addPanel.savedSections.manageTemplates"
    })
  });
};
export default ManageSectionsButton;